import script from "./StatisticsFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticsFilters.vue?vue&type=script&setup=true&lang=ts"

import "./StatisticsFilters.vue?vue&type=style&index=0&id=6b1bf22f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1bf22f"]])

export default __exports__